
import { computed, defineComponent } from 'vue';
import ServicoPedido from '@/servicos/ServicoPedido';
import { EStatusPedido } from '@/models/Enumeradores/EStatusPedido';

export default defineComponent({
  name: 'ComboStatusPedido',
  props: {
    valor: {
      type: Number,
      default: EStatusPedido.EmDigitacao,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    omitir: {
      type: Number,
      default: undefined,
    },
  },
  emits: ['update:valor', 'change'],
  setup(props, { emit }) {
    const servicoPedido = new ServicoPedido();

    const computedValor = computed({
      get: () => props.valor,
      set: (valor: number) => {
        emit('update:valor', valor);
      },
    });

    function defineValorSelecionado(valor: number) {
      emit('update:valor', valor);
      emit('change', valor);
    }

    return {
      props,
      computedValor,
      defineValorSelecionado,
      servicoPedido,
      EStatusPedido,
    };
  },
});
